export const SUCCESS_BANNER_TEXTS = {
    BILL_CLEARED: "Bill cleared",
    TOTAL_AMOUNT: "\u20B9{0}",
    PAID_AMOUNT: "\u20B9{0} paid by you",
    TIP: "including \u20B9{0} as a tip",
    SUBSCRIPTION: "+\u20B9{0} for Swiggy One Plan",
    PAID_SUCCESSFULLY: "\u20B9{0} Paid Successfully",
};

export const TICK_ICON = "v1667544505/dineout/tick.png";
